// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2M3uL","title":"BackImages_title__3Bu7t","images":"BackImages_images__2FKeU"};